<template>
  <div class="h-full" v-if="visible">
    <div class="relative">
      <div class="flex justify-start">
        <p class="mr-20 mb-2">
          <span class="title">推送样本数量：</span>
          <span class="content">{{ allData.quantity }} 个</span>
        </p>
        <p>
          <span class="title">推送时间：</span>
          <span class="content">{{ allData.createTime }}</span>
        </p>
      </div>
      <div class="mb-3">
        <span class="title">目标样本属性：</span>
        <span class="content leading-22">{{ wordStr }}</span>
      </div>

      <!-- 提示信息 -->
      <div class="absolute -right-6" style="top: -62px">
        <p
          class="py-0.5 px-4 rounded-tr-sm rounded-bl-sm text-medium leading-22 font-normal text-white bg-yellow-theme"
          v-if="this.allData.status == 3"
        >
          已撤销
        </p>
        <p
          class="py-0.5 px-4 rounded-tr-sm rounded-bl-sm text-medium leading-22 font-normal text-white text-center"
          style="background-color: #00be6a"
          v-else-if="this.allData.status == 0"
        >
          待审核
        </p>
        <p
          class="py-0.5 px-4 rounded-tr-sm rounded-bl-sm text-medium leading-22 font-normal text-white text-center bg-yellow-theme"
          v-else-if="this.allData.status == 1"
        >
          已推送
        </p>
        <p
          class="py-0.5 px-4 rounded-tr-sm rounded-bl-sm text-medium leading-22 font-normal text-white text-center bg-yellow-theme"
          v-else-if="this.allData.status == 6"
        >
          审核通过，待推送
        </p>
        <p
          class="bg-danger py-0.5 px-4 rounded-tr-sm rounded-bl-sm text-medium leading-22 font-normal text-white text-center truncate max-w-screen-sm"
          v-else-if="this.allData.status == 2"
          ref="err"
        >
          退回原因：
          <el-tooltip placement="bottom-start" :content="this.allData.failReason" :disabled="toolTipDisable">
            <span>{{ this.allData.failReason }}</span>
          </el-tooltip>
        </p>
      </div>

      <div class="dialog-box">
        <el-dialog
          title="撤销该样本库推送？"
          :modal-append-to-body="false"
          :append-to-body="false"
          :visible.sync="repealVisible"
          width="60%"
          top="0vh"
          :close-on-click-modal="false"
          :before-close="handlerDialog"
          :show-close="false"
          center
        >
          <span slot="footer" class="dialog-footer flex justify-center py-4">
            <el-button @click="handlerDialog">暂不撤销</el-button>
            <span class="ml-3"><el-button type="primary" @click="cancelPush">确定撤销</el-button></span>
          </span>
        </el-dialog>
      </div>

      <div class="foot-button">
        <el-button @click="handlerDialog" v-if="this.allData.status == 0">撤销推送</el-button>
        <el-button :disabled="!shoBtn" @click="edit" v-if="this.allData.status == 2">重新编辑</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import ItemContainer from '@/components/base/ItemContainer.vue'
import { getSurveySampleCondition, cancelSampleSend } from '@/api/wenjuan/quota.js'

export default {
  name: 'AlreadyPush',
  components: { ItemContainer },
  props: {
    changeShow: Function,
    hiddenAddBtn: Function,
    changeRePushFlag: Function,
    SurveySampleCondition: Object,
    getData: Function,
    shoBtn: Boolean,
    data: Object,
    id: String
  },
  data() {
    return {
      repealVisible: false, // 撤销弹窗的开关
      allData: {},
      questionData: {},
      titleMap: {
        ages: '年龄段',
        areas: '地区',
        educations: '学历',
        genders: '性别',
        incomes: '月收入状况',
        industries: '行业',
        professions: '职业',
        relations: '婚姻状况'
      },
      areaData: 0,
      visible: false,
      toolTipDisable: false,
      wordStr: '' // 显示用的文字
    }
  },
  methods: {
    handlerDialog() {
      this.repealVisible = !this.repealVisible
    },
    // 重新编辑执行的事件
    edit() {
      this.$emit('changeShow')
      this.$emit('hiddenAddBtn')
      // 打开重新推送的开关
      this.$emit('changeRePushFlag')
    },
    // 撤销当前任务的推送
    cancelPush() {
      cancelSampleSend({ id: this.id })
        .then(res => {
          if (res.data.code === 0) {
            this.repealVisible = false
            this.$message.success('推送已取消~')
            this.allData.status = 3
            this.$emit('getData')
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 撤销后的重新编辑
    cancelAddEdit() {
      // 先执行撤销
      cancelSampleSend({ id: this.id })
        .then(res => {
          if (res.data.code === 0) {
            this.repealVisible = false
            this.$message.success('撤销成功')
          }
        })
        .catch(err => {
          console.log(err)
        })
      // 再关闭弹窗
      this.repealVisible = false
      // 再进行重新编辑
      this.edit()
    }
  },
  created() {
    // 获取多选项
    let data = JSON.parse(JSON.stringify(this.SurveySampleCondition))

    delete data.availableQuantity
    delete data.areas
    this.questionData = data
    for (let key in this.questionData) {
      this.questionData[key] = this.questionData[key].slice(1)
    }
    // 获取勾选内容
    if (this.data) {
      this.allData = JSON.parse(this.data.screeningCondition)
    }
    this.allData.industries = this.allData.industrys

    // 根据数据生成显示的文字
    let str = ''
    for (let i in this.questionData) {
      if (this.allData[i].length) {
        str += this.titleMap[i] + ' = '
        this.allData[i].forEach(item => {
          this.questionData[i].forEach(v => {
            if (v.key == item) {
              str += v.value + '/'
            }
          })
        })
        // 修改最后一个字符
        let length = str.length
        let arr = str.split('')
        arr[length - 1] = '；'
        str = arr.join('')
      }
    }

    this.allData.status = this.data.status

    this.allData.industries = this.data.industrys
    this.allData.quantity = this.data.quantity
    this.allData.actualQuantity = this.data.actualQuantity
    this.allData.createTime = this.data.createTime
    if (this.data.failReason) {
      this.allData.failReason = this.data.failReason
    }

    for (let key in this.allData) {
      if (Array.isArray(this.allData[key])) {
        this.allData[key] = this.allData[key].map(item => {
          return item + ''
        })
      } else if (this.allData[key] == null) {
        this.allData[key] = []
      }
    }
    this.areaData = this.allData.areas
    if (this.areaData.length) {
      str += '地区：'
      str += this.areaData.join('、') + '；'
    }
    this.wordStr = str ? str : '无限制'

    this.visible = true
  }
}
</script>

<style scoped lang="scss">
.textColor {
  color: #c0c4d5;
}
.el-icon-time {
  margin-right: 5px;
  color: #e6a23c;
}
.el-icon-circle-check {
  margin-right: 5px;
  color: #70b603;
}
.el-icon-circle-close {
  margin-right: 5px;
  color: #d9001b;
}
.checkbox-group {
  ::v-deep .el-checkbox-group {
    .el-checkbox-button {
      @apply relative;
      .el-checkbox-button__inner {
        border-left-width: 0px !important;
        @apply border-l-0 border-r-0;
        &::before {
          content: '';
          @apply absolute -top-px -left-px w-px overflow-hidden z-10;
          border-left: 1px solid #ebeef5;
          height: calc(100% + 2px);
        }
        &::after {
          content: '';
          @apply absolute top-0 right-0 w-px h-full overflow-hidden z-0;
          border-right: 1px solid #ebeef5;
        }
      }
    }
    .is-checked {
      .el-checkbox-button__inner {
        &::before {
          content: '';
          border-left: 1px solid;
          height: calc(100% + 2px);
          @apply absolute -top-px -left-px w-px h-full overflow-hidden z-30 border-theme;
        }
        &::after {
          content: '';
          border-right: 1px solid;
          height: calc(100% + 2px);
          @apply absolute -top-px right-0 w-px h-full overflow-hidden z-20 border-theme;
        }
      }
    }
  }
}
::v-deep .el-dialog {
  @apply bg-transparent shadow-none mb-0;
}
::v-deep .el-dialog__header {
  @apply flex justify-center p-0 mb-4;
}
::v-deep .el-dialog__body {
  @apply p-0;
}
::v-deep .el-dialog__footer {
  @apply p-0;
  .dialog-footer {
    @apply p-0;
  }
}
::v-deep .el-dialog__wrapper {
  position: absolute !important;
}
::v-deep .v-modal {
  @apply opacity-100;
  position: absolute !important;
  width: calc(100% + 48px);
  height: calc(100% + 78px);
  left: -24px;
  top: -62px;
  background-color: rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(6px);
}
.title {
  @apply text-medium leading-22 text-theme-black-450;
}
.content {
  @apply text-theme-black-850;
}
</style>
